module.exports = __webpack_public_path__ + "static/sport/icon-200.a1b3409.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/icon-200.png
// module id = SzEe
// module chunks = 0